import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  list: [],
  loading: false,
  error: null,
};

const employeesSlice = createSlice({
  name: "employees",
  initialState,
  reducers: {
    // Fed by the Firebase listener in useEmployees, not by components.
    setEmployees: (state, action) => {
      state.list = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const { setEmployees, setLoading, setError } = employeesSlice.actions;

// The live team list. One selector, so the state shape is known here and not
// at every useSelector call.
export const selectEmployees = (state) => state.employees.list;

export default employeesSlice.reducer;
